import { supabase } from '@/lib/supabase'

export async function fetchAssetsMeta(symbols: string[]): Promise<Array<{ symbol: string; name?: string | null; base_asset?: string | null; logo_url?: string | null }>> {
  if (!symbols.length) return []
  const { data } = await supabase
    .from('crypto_assets')
    .select('symbol,name,base_asset,logo_url')
    .in('symbol', symbols)
  return (data as any[]) || []
}

